import { Action } from "@/api-schema-enums";
import { useCasaviContactBlacklistByUuidQuery } from "@/common/api/casavi/contact-blacklist/use-casavi-contact-blacklist-by-uuid.query";
import { CenteredLayout, CenteredLayoutVariant } from "@/components/layouts/centered-layout";
import { Loader, LoaderSize } from "@/components/ui/loader";
import { useTranslation } from "react-i18next";
import { useParams } from "wouter";
import { ContactBlacklistForm } from "../_components/contact-blacklist-form";

export function CasaviContactBlacklistUpdateView() {
  const { t } = useTranslation(["casavi"]);
  const pageTitle = t("casavi:EditBlacklistEntry");
  const pageSubtitle = t("casavi:EditCasaviContactBlacklistEntry");
  const { uuid } = useParams<{ uuid: string }>();
  const { data: contactBlacklist, isLoading } = useCasaviContactBlacklistByUuidQuery(uuid || "");

  const content = isLoading ? (
    <div className="flex h-64 items-center justify-center">
      <Loader size={LoaderSize.Medium} />
    </div>
  ) : !contactBlacklist ? (
    <p className="text-muted-foreground text-sm">{t("casavi:EntryNotFound")}</p>
  ) : (
    <ContactBlacklistForm
      key={`${contactBlacklist.uuid}-${contactBlacklist.updatedAt}`}
      mode={Action.Update}
      initialData={contactBlacklist}
      uuid={uuid}
    />
  );

  return (
    <CenteredLayout variant={CenteredLayoutVariant.Form} title={pageTitle} subTitle={pageSubtitle}>
      {content}
    </CenteredLayout>
  );
}
